import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
// import tableStyle from '../../CustomerSuccess/styles/tableStyle'
import {
  countOrACVFormatter,
  customDateFormatter,
  getUniqueValues,
  StyledTableRow,
} from "../../util/customFunctions";

import { makeStyles } from "@material-ui/core";
import isThisQuarter from "date-fns/esm/isThisQuarter/index";
import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";
// import ExcelExportButton from "../../components/xlsx-export/xlsxexport";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CustomWidthTooltip from "../../components/Buttons/Expand_Collapse_Tooltip";
import { replaceAll } from "../../components/xlsx-export/LabelCange";

const tableStyle = makeStyles(
  (theme) => ({
    root: {
      margin: "0.5rem",
      padding: "0.5rem",
    },
    sticky: {
      position: "sticky",
      left: -1,
      background: "white",
      // outline: "0.5px solid lightgrey",
      // outlineOffset: "-1.5px",
      // Create a pseudo-element for the fixed right border
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        width: "0.5px", // Adjust the thickness as needed
        background: "lightgrey", // Adjust the color as needed
      },
    },
    stickyHeader: {
      position: "sticky",
      top: -1,
      background: "white",
      outline: "0.2px solid lightgrey",
      outlineOffset: "-1.5px",
      zIndex: 5,
      // Create a pseudo-element for the fixed right border
      "&::after": {
        content: '""',
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        width: "0.5px", // Adjust the thickness as needed
        // background: "lightgrey", // Adjust the color as needed
      },
    },
    colHeaderNew: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      width: 120,
      fontWeight: "inherit",
      backgroundColor: "inherit",
    },
    colHeader: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      width: 120,
      fontWeight: 600,
    },
    dataCell: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      width: 120,
      fontWeight: "inherit",
    },
    drilldownCell: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      width: 120,
      fontWeight: "inherit",
      cursor: "pointer",
    },
    drilldownCellNQP: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      width: "3%",
      fontWeight: "inherit",
      cursor: "pointer",
    },
    cellMargin: {
      fontSize: "0.85rem",
      border: "0.5px solid lightgrey",
      padding: "7px 10px",
      color: "inherit",
      width: 120,
      fontWeight: "inherit",
      paddingLeft: "2rem",
    },
    fontBold: {
      fontWeight: 600,
    },
    indentName: {
      paddingLeft: 30,
    },
    noBorder: {
      border: "none",
    },
    primaryColumnColor: {
      backgroundColor: "#4472C4",
      color: "white",
    },
  }),
  { index: 1 }
);

function QualifiedPipelineTable(props) {
  const tableRef = React.createRef();

  const tableContainerRef = useRef();

  const [isOverflowing, setIsOverflowing] = useState(false);

  const [isSticky, setIsSticky] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  // const [globalExpandArrow, setglobalExpandArrow] = useState(false);
  const [rowPin, setrowPin] = useState(false);
  const [parentWidth, setparentWidth] = useState();

  let globalExpand = [];

  const handleExpandClick = (rowId) => {
    setExpandedRows((prevExpandedRows) => {
      const isRowExpanded = prevExpandedRows.includes(rowId);
      if (isRowExpanded) {
        return prevExpandedRows.filter((expandedRow) => expandedRow !== rowId);
      } else {
        return [...prevExpandedRows, rowId];
      }
    });
  };

  useEffect(() => {
    setExpandedRows(globalExpand);
  }, []);

  const globalExpandData = (con) => {
    if (con === true) {
      setExpandedRows(globalExpand);
      // setglobalExpandArrow(true);
    } else {
      setExpandedRows([]);
      // setglobalExpandArrow(false);
    }
  };

  let countinc = 0;

  // let countinc = 0;

  const handleDrilldown = (rep, weekEnding, isAverage, metaData) => {
    // console.log(rep, weekEnding, isAverage, metaData)
    props.drilldown(rep, weekEnding, isAverage, metaData);
  };
  
  // ✅ HELPER FUNCTION TO CREATE METADATA SAFELY
  const createMetaData = (cellData, props) => {
    if (!cellData) return null;
    
    return [
      {
        label: "Avg. deal size",
        type: "ACV",
        value: Math.round(
          cellData[
            props.isColDate
              ? "Average_Acv"
              : `trailing${cellData.weekEnding}${props.avgCol3}`
          ] || 0
        ),
      },
      {
        label: "# of Opps",
        type: "count",
        value: cellData[
          props.isColDate
            ? "Number_of_Opps"
            : `trailing${cellData.weekEnding}WeeksAverageCount`
        ] || 0,
      },
      {
        label: "ACV",
        type: "ACV",
        value: Math.round(
          cellData[
            props.isColDate
              ? "Acv_at_Qualfied"
              : `trailing${cellData.weekEnding}${props.avgCol2}`
          ] || 0
        ),
      },
      {
        label: "week Ending",
        value:
          cellData.weekEnding === "Twelve"
            ? 12
            : cellData.weekEnding === "Eight"
            ? 8
            : 4,
      },
    ];
  };
  
  const thresholds = props.thresholds;
  const colorConfig = props.colorConfig || [];
  const classes = tableStyle();
  const valLabel = props.Value_Label || "ACV";

  const isTorqWeeklyColoringEnabled =
    props.company === "C0023" && colorConfig.length > 0;
  const weeklyRepTypes = [...new Set(
    colorConfig
      .filter(
        (item) =>
          String(item.Period || item.period || "").toLowerCase() === "weekly" &&
          ![undefined, null, ""].includes(item.Rep_Type || item.rep_type)
      )
      .map((item) => String(item.Rep_Type || item.rep_type))
  )].sort();

  const isWeeklyRepExcludedFromColorCoding = (repRows) => {
    if (!isTorqWeeklyColoringEnabled || !props.isColDate || !Array.isArray(repRows) || repRows.length === 0) {
      return false;
    }

    return repRows.some((row) => {
      if (!row || ["team", "total"].includes(row.Owner_Name)) return false;
      const repType = row.rep_type;
      const goal = Number(row.goalAcvWeekly);

      return [undefined, null, ""].includes(repType) || !(goal > 0);
    });
  };

  const hasExcludedWeeklyReps =
    isTorqWeeklyColoringEnabled &&
    props.isColDate &&
    props.data.some(
      (item) =>
        !["team", "total"].includes(item.Owner_Name) &&
        isWeeklyRepExcludedFromColorCoding(
          props.data.filter((row) => row.Owner_Name === item.Owner_Name)
        )
    );

  const getWeeklyRepCellColor = (cellData, isCount) => {
    if (!isTorqWeeklyColoringEnabled || !cellData) return {};
    if (["team", "total"].includes(cellData.Owner_Name)) return {};
    if (isWeeklyRepExcludedFromColorCoding([cellData])) return {};

    const repType = cellData.rep_type;
    if ([undefined, null, ""].includes(repType)) return {};

    const value = isCount ? cellData.Number_of_Opps : cellData[props.acvCol];
    if (value == null || value === "-") return {};

    const numericVal = Number(value);
    if (Number.isNaN(numericVal)) return {};

    const goal = Number(cellData.goalAcvWeekly);
    const attainmentValue = !isCount && goal > 0 ? numericVal / goal : numericVal;

    const typeConfig = colorConfig
      .filter(
        (item) =>
          String(item.Period || item.period || "").toLowerCase() === "weekly" &&
          String(item.Rep_Type || item.rep_type || "").toLowerCase() ===
            String(repType).toLowerCase()
      )
      .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

    if (typeConfig.length === 0) return {};

    for (const band of typeConfig) {
      if (isCount) {
        const low = band.low_greater_than_or_equal_to_number_of_opps;
        const high = band.high_less_than_number_of_opps;
        if (low !== null && low !== undefined && numericVal < Number(low)) continue;
        if (high !== null && high !== undefined && numericVal >= Number(high)) continue;
        return { backgroundColor: band.color, color: band.text_color };
      }

      const low = band.low_greater_than_or_equal_to_percent;
      const high = band.high_less_than_percent;
      if (goal <= 0 || Number.isNaN(attainmentValue)) return {};
      if (low !== null && low !== undefined && attainmentValue < Number(low)) continue;
      if (high !== null && high !== undefined && attainmentValue >= Number(high)) continue;
      return { backgroundColor: band.color, color: band.text_color };
    }

    return {};
  };

  useEffect(() => {
    const tableContainer = document.getElementById("myTableContainer-Second");

    const handleOverflowCheck = () => {
      if (tableContainer) {
        setIsOverflowing(
          tableContainer.scrollWidth > tableContainer.offsetWidth
        );
      }
    };

    // Check for overflow initially and whenever the component updates
    handleOverflowCheck();

    // Attach a resize event listener to check for overflow when the window is resized
    window.addEventListener("resize", handleOverflowCheck);

    return () => {
      // Clean up the event listener when the component unmounts
      window.removeEventListener("resize", handleOverflowCheck);
    };
  }, []);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleScroll = () => {
      if (tableContainer.scrollLeft > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      if (tableContainer.scrollTop > 0) {
        setrowPin(true);
      } else {
        setrowPin(false);
      }
    };

    // Attach a scroll event listener to the TableContainer
    tableContainer.addEventListener("scroll", handleScroll);

    return () => {
      // Clean up the event listener when the component unmounts
      tableContainer.removeEventListener("scroll", handleScroll);
    };
  }, [classes.sticky]);

  useEffect(() => {
    // Get the width of the parent TableContainer
    const parentWidth = tableContainerRef.current.getBoundingClientRect().width;
    setparentWidth(parentWidth);
  }, [parentWidth]);

  return (
    <div
      style={{ maxWidth: "100%", justifyContent: "center", padding: "2rem" }}
    >
      <Grid xs={12}>
        {parentWidth !== undefined ? (
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginBottom: "0.6rem",
              // marginRight: "1rem",
              width: `${
                tableContainerRef.current.getBoundingClientRect().width
              }px`,
            }}  
          >
            <CopyTablesObject tableRef={tableRef} />
          </div>
        ) : null}
      </Grid>
      <TableContainer
        style={{
          width: "auto",
          borderLeft: isSticky ? "0.5px solid lightgrey" : "",
          borderTop: rowPin ? "0.5px solid lightgrey" : "",
          maxHeight: "85vh",
        }}
        id="myTableContainer-Second"
        ref={tableContainerRef}
      >
        <Table ref={tableRef} data-test={props.name} id={props.dataID}>
          <TableHead style={{ position: "sticky", top: -1, zIndex: 5 }}>
            <TableRow
              style={{ position: "sticky", outline: "lightgrey solid 0.5px" }}
            >
              <TableCell
                // className={classes.colHeader}
                className={
                  isSticky
                    ? `${classes.sticky} ${classes.colHeader}`
                    : classes.colHeader
                }
                style={{
                  minWidth: 150,
                  whiteSpace: "nowrap",
                  background: "white",
                }}
              >
                {props.tableHeading}
              </TableCell>
              <TableCell
                className={classes.colHeader}
                style={{ background: "white" }}
              ></TableCell>
              {props.traillingColumns
                ? props.traillingColumns.map((col, index) => (
                    <TableCell
                      colSpan={3}
                      style={
                        index % 2 === 0
                          ? { background: "#4471c4", color: "white" }
                          : { background: "#5b9bd5", color: "white" }
                      }
                      align="center"
                      className={classes.colHeader}
                    >
                      {props.isColDate
                        ? customDateFormatter(col)
                        : col + " Avg."}
                    </TableCell>
                  ))
                : props.columns.map((col, index) => (
                    <TableCell
                      colSpan={3}
                      style={
                        index % 2 === 0
                          ? { background: "#4471c4", color: "white" }
                          : { background: "#5b9bd5", color: "white" }
                      }
                      align="center"
                      className={classes.colHeader}
                    >
                      {props.isColDate
                        ? customDateFormatter(col)
                        : col + " Avg."}
                    </TableCell>
                  ))}
            </TableRow>
            <StyledTableRow
              style={{ position: "sticky", outline: "lightgrey solid 0.5px" }}
            >
              <TableCell
                // className={classes.colHeader}
                className={
                  isSticky
                    ? `${classes.sticky} ${classes.colHeader}`
                    : classes.colHeader
                }
                style={{
                  // outline: "lightgrey solid 1px",
                  // outlineOffset: "-1.5px",
                  background: "white",
                }}
              >
                {/* Team / AE */}
                <div style={{ display: "flex" }}>
                  <div style={{ marginTop: "2.5px" }}>Team / AE</div>

                  <CustomWidthTooltip
                    title={"Expand All"}
                    placement="top-start"
                    style={{ marginTop: "13rem" }}
                  >
                    <KeyboardArrowDownIcon
                      onClick={() => globalExpandData(true)}
                      style={{ color: "gray" }}
                    />
                  </CustomWidthTooltip>
                  <CustomWidthTooltip
                    title={"Collapse All"}
                    placement="top-start"
                  >
                    <KeyboardArrowUpIcon
                      onClick={() => globalExpandData(false)}
                      style={{ color: "gray" }}
                    />
                  </CustomWidthTooltip>
                </div>
              </TableCell>
              <TableCell
                style={{ minWidth: 90, background: "white" }}
                align="center"
                className={classes.colHeader}
              >
                <p>{props.goalheader}</p> <p>Goal</p>
              </TableCell>
              {props.columns.map((col) =>
                props.subColumns.map((item) => (
                  <TableCell
                    align="center"
                    style={{ background: "white" }}
                    className={classes.colHeader}
                  >
                    {/* {item}  */}
                    {replaceAll(item, "acv", `${props.Value_Label}`)}
                  </TableCell>
                ))
              )}
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {props.teamNames.map((team, i) => {
              globalExpand.push(i);
              countinc = countinc + 1;
              const teamData = props.data.filter(
                (item) => item.Owner_Name === "team" && item.team === team
              );
              const repData = props.data.filter((item) => item.team === team);
              const reps = props.data
                .filter(
                  (item) =>
                    item.team === team &&
                    !["team", "total"].includes(item.Owner_Name)
                )
                .map((item) => item.Owner_Name)
                .filter(getUniqueValues)
                .sort();
              let teamThreshold = thresholds.filter(
                (item) => item.Team === team
              );
              teamThreshold =
                teamThreshold.length >= 1
                  ? ![null, undefined, ""].includes(
                      teamThreshold[0]["Threshold"]
                    )
                    ? teamThreshold[0]["Threshold"]
                    : undefined
                  : undefined;
              return (
                <>
                  {" "}
                  <StyledTableRow
                    key={i}
                    className={classes.fontBold}
                    style={{ background: "#dae3f3" }}
                  >
                    <TableCell
                      // className={classes.colHeader}
                      className={
                        isSticky
                          ? `${classes.sticky} ${classes.colHeader}`
                          : `${classes.colHeader}`
                      }
                      style={
                        isSticky && countinc % 2 === 1
                          ? { background: "#dae3f3" }
                          : { background: "#dae3f3" }
                      }
                      onClick={() => handleExpandClick(i)}
                    >
                      {/* {team} */}
                      <div style={{ display: "flex" }}>
                        {team !== "Grand Total" ? (
                          expandedRows.includes(i) ? (
                            <KeyboardArrowUpIcon style={{ color: "gray" }} />
                          ) : (
                            <KeyboardArrowDownIcon style={{ color: "gray" }} />
                          )
                        ) : null}
                        <div style={{ marginTop: "3px" }}>{team}</div>
                      </div>
                    </TableCell>
                    <TableCell align="right" className={classes.colHeader}>
                      {teamThreshold !== undefined
                        ? countOrACVFormatter(teamThreshold, true)
                        : "-"}
                    </TableCell>
                    {props.columns.map((col) => {
                      const cellData = teamData.filter(
                        (item) => item[props.timeFrameEnding] === col
                      )[0];
                      
                      // ✅ CREATE METADATA SAFELY
                      const metaData = createMetaData(cellData, props);
                      
                      // ✅ CHECK IF CELLDATA EXISTS
                      if (!cellData) {
                        return props.isColDate ? (
                          <>
                            <TableCell align="right" className={classes.drilldownCell}>
                              0
                            </TableCell>
                            <TableCell align="right" className={classes.drilldownCell} style={{ minWidth: 90 }}>
                              {countOrACVFormatter(0, true)}
                            </TableCell>
                            <TableCell align="right" className={classes.drilldownCell}>
                              {countOrACVFormatter(0, true)}
                            </TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell align="right" className={classes.drilldownCell}>
                              0.0
                            </TableCell>
                            <TableCell align="right" className={classes.drilldownCell} style={{ minWidth: 90 }}>
                              {countOrACVFormatter(0, true)}
                            </TableCell>
                            <TableCell align="right" className={classes.drilldownCell}>
                              {countOrACVFormatter(0, true)}
                            </TableCell>
                          </>
                        );
                      }
                      
                      return props.isColDate ? (
                        <>
                          <TableCell
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                col,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {cellData[`Number_of_Opps`] || 0}
                          </TableCell>
                          <TableCell
                            style={
                              isTorqWeeklyColoringEnabled
                                ? { minWidth: 90 }
                                : ![undefined, 0].includes(teamThreshold)
                                ? teamThreshold <= cellData[props.acvCol]
                                  ? { backgroundColor: "#e2efda", minWidth: 90 }
                                  : { minWidth: 90 }
                                : { minWidth: 90 }
                            }
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                col,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {countOrACVFormatter(
                              cellData[props.acvCol] || 0,
                              true
                            )}
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                col,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {countOrACVFormatter(
                              cellData[props.avgCol] || 0,
                              true
                            )}
                          </TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                cellData.weekEnding,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {(cellData[
                              `trailing${cellData.weekEnding}WeeksAverageCount`
                            ] || 0).toFixed(1)}
                          </TableCell>
                          <TableCell
                            style={
                              ![undefined, 0].includes(teamThreshold)
                                ? teamThreshold <=
                                  cellData[
                                    `trailing${cellData.weekEnding}${props.avgCol2}`
                                  ]
                                  ? { backgroundColor: "#e2efda", minWidth: 90 }
                                  : { minWidth: 90 }
                                : { minWidth: 90 }
                            }
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                cellData.weekEnding,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {countOrACVFormatter(
                              cellData[
                                `trailing${cellData.weekEnding}${props.avgCol2}`
                              ] || 0,
                              true
                            )}
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                cellData.weekEnding,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {countOrACVFormatter(
                              cellData[
                                `trailing${cellData.weekEnding}${props.avgCol3}`
                              ] || 0,
                              true
                            )}
                          </TableCell>
                        </>
                      );
                    })}
                  </StyledTableRow>
                  {expandedRows.includes(i) &&
                    reps.map((rep, i) => {
                      countinc = countinc + 1;
                      const repsData = repData.filter(
                        (item) => item.Owner_Name === rep
                      );
                      const excludeFromWeeklyColorCoding =
                        isWeeklyRepExcludedFromColorCoding(repsData);
                      let repThreshold = thresholds.filter(
                        (item) => item.Team === rep
                      );
                      repThreshold =
                        repThreshold.length >= 1
                          ? ![null, undefined, ""].includes(
                              repThreshold[0]["Threshold"]
                            )
                            ? repThreshold[0]["Threshold"]
                            : undefined
                          : undefined;
                      return (
                        <StyledTableRow key={i}>
                          <TableCell
                            // className={`${classes.dataCell} ${classes.indentName}`}
                            className={
                              isSticky
                                ? `${classes.sticky} ${classes.dataCell} ${classes.indentName}`
                                : `${classes.dataCell} ${classes.indentName}`
                            }
                            style={
                              isSticky && countinc % 2 === 1
                                ? {
                                    background: "#f5f5f5",
                                    paddingLeft: "25px",
                                    whiteSpace: "nowrap",
                                  }
                                : { paddingLeft: "25px", whiteSpace: "nowrap" }
                            }
                          >
                            {rep}
                            {excludeFromWeeklyColorCoding && (
                              <span style={{ color: "#f57c00", marginLeft: "4px", fontWeight: 700 }}>
                                *
                              </span>
                            )}
                          </TableCell>
                          <TableCell
                            align="right"
                            className={classes.colHeader}
                          >
                            {repThreshold !== undefined
                              ? countOrACVFormatter(repThreshold, true)
                              : "-"}
                          </TableCell>
                          {props.columns.map((col) => {
                            const cellData = repsData.filter(
                              (item) => item[props.timeFrameEnding] === col
                            )[0];
                            
                            // ✅ CREATE METADATA SAFELY
                            const metaData = createMetaData(cellData, props);
                            
                            // ✅ CHECK IF CELLDATA EXISTS
                            if (!cellData) {
                              return props.isColDate ? (
                                <>
                                  <TableCell align="right" className={classes.drilldownCell}>
                                    0
                                  </TableCell>
                                  <TableCell align="right" className={classes.drilldownCell} style={{ minWidth: 90 }}>
                                    {countOrACVFormatter(0, true)}
                                  </TableCell>
                                  <TableCell align="right" className={classes.drilldownCell}>
                                    {countOrACVFormatter(0, true)}
                                  </TableCell>
                                </>
                              ) : (
                                <>
                                  <TableCell align="right" className={classes.drilldownCell}>
                                    0.0
                                  </TableCell>
                                  <TableCell align="right" className={classes.drilldownCell} style={{ minWidth: 90 }}>
                                    {countOrACVFormatter(0, true)}
                                  </TableCell>
                                  <TableCell align="right" className={classes.drilldownCell}>
                                    {countOrACVFormatter(0, true)}
                                  </TableCell>
                                </>
                              );
                            }
                            
                            return props.isColDate ? (
                              <>
                                <TableCell
                                  style={getWeeklyRepCellColor(cellData, true)}
                                  onClick={() =>
                                    handleDrilldown(
                                      [rep],
                                      col,
                                      props.isAverage,
                                      props.isAverage ? metaData : null
                                    )
                                  }
                                  align="right"
                                  className={classes.drilldownCell}
                                >
                                  {cellData[`Number_of_Opps`] || 0}
                                </TableCell>
                                <TableCell
                                  onClick={() =>
                                    handleDrilldown(
                                      [rep],
                                      col,
                                      props.isAverage,
                                      props.isAverage ? metaData : null
                                    )
                                  }
                                  style={{
                                    minWidth: 90,
                                    ...getWeeklyRepCellColor(cellData, false),
                                  }}
                                  align="right"
                                  className={classes.drilldownCell}
                                >
                                  {countOrACVFormatter(
                                    cellData[props.acvCol] || 0,
                                    true
                                  )}
                                </TableCell>
                                <TableCell
                                  onClick={() =>
                                    handleDrilldown(
                                      [rep],
                                      col,
                                      props.isAverage,
                                      props.isAverage ? metaData : null
                                    )
                                  }
                                  align="right"
                                  className={classes.drilldownCell}
                                >
                                  {countOrACVFormatter(
                                    cellData[props.avgCol] || 0,
                                    true
                                  )}
                                </TableCell>
                              </>
                            ) : (
                              <>
                                <TableCell
                                  onClick={() =>
                                    handleDrilldown(
                                      [rep],
                                      cellData.weekEnding,
                                      props.isAverage,
                                      props.isAverage ? metaData : null
                                    )
                                  }
                                  align="right"
                                  className={classes.drilldownCell}
                                >
                                  {(cellData[
                                    `trailing${cellData.weekEnding}WeeksAverageCount`
                                  ] || 0).toFixed(1)}
                                </TableCell>
                                <TableCell
                                  onClick={() =>
                                    handleDrilldown(
                                      [rep],
                                      cellData.weekEnding,
                                      props.isAverage,
                                      props.isAverage ? metaData : null
                                    )
                                  }
                                  style={
                                    ![undefined, 0].includes(repThreshold)
                                      ? repThreshold <=
                                        cellData[
                                          `trailing${cellData.weekEnding}${props.avgCol2}`
                                        ]
                                        ? {
                                            backgroundColor: "#e2efda",
                                            minWidth: 90,
                                          }
                                        : { minWidth: 90 }
                                      : { minWidth: 90 }
                                  }
                                  align="right"
                                  className={classes.drilldownCell}
                                >
                                  {countOrACVFormatter(
                                    cellData[
                                      `trailing${cellData.weekEnding}${props.avgCol2}`
                                    ] || 0,
                                    true
                                  )}
                                </TableCell>
                                <TableCell
                                  onClick={() =>
                                    handleDrilldown(
                                      [rep],
                                      cellData.weekEnding,
                                      props.isAverage,
                                      props.isAverage ? metaData : null
                                    )
                                  }
                                  align="right"
                                  className={classes.drilldownCell}
                                >
                                  {countOrACVFormatter(
                                    cellData[
                                      `trailing${cellData.weekEnding}${props.avgCol3}`
                                    ] || 0,
                                    true
                                  )}
                                </TableCell>
                              </>
                            );
                          })}
                        </StyledTableRow>
                      );
                    })}
                </>
              );
            })}
            {props.data
              .filter((item) => item.Owner_Name === "total")
              .map((item) => item.Owner_Name)
              .filter(getUniqueValues)
              .map((item, i) => {
                const totalData = props.data.filter(
                  (item) => item.Owner_Name === "total"
                );
                let totalThreshold = thresholds.filter(
                  (item) => item.Team === "Company"
                );
                totalThreshold =
                  totalThreshold.length >= 1
                    ? ![null, undefined, ""].includes(
                        totalThreshold[0]["Threshold"]
                      )
                      ? totalThreshold[0]["Threshold"]
                      : undefined
                    : undefined;
                return (
                  <StyledTableRow
                    key={i}
                    className={classes.fontBold}
                    style={{ background: "#dae3f3" }}
                  >
                    <TableCell
                      // className={classes.colHeader}
                      className={
                        isSticky
                          ? `${classes.sticky} ${classes.colHeader}`
                          : classes.colHeader
                      }
                      style={
                        isSticky && (countinc + 1) % 2 === 1
                          ? { background: "#dae3f3", paddingLeft: "25px" }
                          : { paddingLeft: "25px", background: "#dae3f3" }
                      }
                    >
                      Total
                    </TableCell>
                    <TableCell align="right" className={classes.colHeader}>
                      {totalThreshold !== undefined
                        ? countOrACVFormatter(totalThreshold, true)
                        : "-"}
                    </TableCell>
                    {props.columns.map((col) => {
                      const cellData = totalData.filter(
                        (item) => item[props.timeFrameEnding] === col
                      )[0];
                      const reps = props.data
                        .filter(
                          (f) =>
                            f.Owner_Name !== "total" && f.Owner_Name !== "team"
                        )
                        .map((item) => item.Owner_Name)
                        .filter(getUniqueValues);
                      
                      // ✅ CREATE METADATA SAFELY
                      const metaData = createMetaData(cellData, props);
                      
                      // ✅ CHECK IF CELLDATA EXISTS
                      if (!cellData) {
                        return props.isColDate ? (
                          <>
                            <TableCell align="right" className={classes.drilldownCell}>
                              0
                            </TableCell>
                            <TableCell align="right" className={classes.drilldownCell} style={{ minWidth: 90 }}>
                              {countOrACVFormatter(0, true)}
                            </TableCell>
                            <TableCell align="right" className={classes.drilldownCell}>
                              {countOrACVFormatter(0, true)}
                            </TableCell>
                          </>
                        ) : (
                          <>
                            <TableCell align="right" className={classes.drilldownCell}>
                              0.0
                            </TableCell>
                            <TableCell align="right" className={classes.drilldownCell} style={{ minWidth: 90 }}>
                              {countOrACVFormatter(0, true)}
                            </TableCell>
                            <TableCell align="right" className={classes.drilldownCell}>
                              {countOrACVFormatter(0, true)}
                            </TableCell>
                          </>
                        );
                      }

                      return props.isColDate ? (
                        <>
                          <TableCell
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                col,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {cellData[`Number_of_Opps`] || 0}
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                col,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                              style={
                                isTorqWeeklyColoringEnabled
                                  ? { minWidth: 90 }
                                  : ![undefined, 0].includes(totalThreshold)
                                  ? totalThreshold <= cellData[props.acvCol]
                                    ? { backgroundColor: "#e2efda", minWidth: 90 }
                                    : { minWidth: 90 }
                                : { minWidth: 90 }
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {countOrACVFormatter(
                              cellData[props.acvCol] || 0,
                              true
                            )}
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                col,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {countOrACVFormatter(
                              cellData[props.avgCol] || 0,
                              true
                            )}
                          </TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                cellData.weekEnding,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {(cellData[
                              `trailing${cellData.weekEnding}WeeksAverageCount`
                            ] || 0).toFixed(1)}
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                cellData.weekEnding,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            style={
                              ![undefined, 0].includes(totalThreshold)
                                ? totalThreshold <=
                                  cellData[
                                    `trailing${cellData.weekEnding}${props.avgCol2}`
                                  ]
                                  ? { backgroundColor: "#e2efda", minWidth: 90 }
                                  : { minWidth: 90 }
                                : { minWidth: 90 }
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {countOrACVFormatter(
                              cellData[
                                `trailing${cellData.weekEnding}${props.avgCol2}`
                              ] || 0,
                              true
                            )}
                          </TableCell>
                          <TableCell
                            onClick={() =>
                              handleDrilldown(
                                reps,
                                cellData.weekEnding,
                                props.isAverage,
                                props.isAverage ? metaData : null
                              )
                            }
                            align="right"
                            className={classes.drilldownCell}
                          >
                            {countOrACVFormatter(
                              cellData[
                                `trailing${cellData.weekEnding}${props.avgCol3}`
                              ] || 0,
                              true
                            )}
                          </TableCell>
                        </>
                      );
                    })}
                  </StyledTableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      {isTorqWeeklyColoringEnabled && (
        <div
          style={{
            marginTop: "1rem",
            width: "100%",
            fontSize: "0.85rem",
            paddingTop: "0.5rem",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexWrap: "wrap",
              padding: "0 10px",
            }}
          >
            {weeklyRepTypes.map((rType) => {
              const bands = colorConfig
                .filter(
                  (c) =>
                    String(c.Period || c.period || "").toLowerCase() === "weekly" &&
                    String(c.Rep_Type || c.rep_type || "").toLowerCase() ===
                      rType.toLowerCase()
                )
                .sort((a, b) => (a.sequence || 0) - (b.sequence || 0));

              if (bands.length === 0) return null;

              return (
                <div key={rType} style={{ width: "48%", marginBottom: "1rem" }}>
                  <div style={{ fontWeight: 700, fontSize: "1rem", margin: "5px 0 8px" }}>
                    {rType}:
                  </div>

                  <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "5px" }}>
                    <span style={{ fontWeight: 600, width: "130px", flexShrink: 0, whiteSpace: "nowrap" }}>
                      # of Opps:
                    </span>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
                      {bands.map((b, idx) => {
                        const low = b.low_greater_than_or_equal_to_number_of_opps;
                        const high = b.high_less_than_number_of_opps;
                        let label = "";

                        if (low == null && high != null) label = `<${high}`;
                        else if (low != null && high == null) label = `>=${low}`;
                        else label = `>=${low} to <${high}`;

                        return (
                          <div key={`opp-${rType}-${idx}`} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                            <div style={{ width: "15px", height: "15px", backgroundColor: b.color, marginRight: "5px", flexShrink: 0 }}></div>
                            <span style={{ fontSize: "0.75rem" }}>{label}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "flex-start" }}>
                    <span style={{ fontWeight: 600, width: "130px", flexShrink: 0, whiteSpace: "nowrap" }}>
                      {valLabel}:
                    </span>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
                      {bands.map((b, idx) => {
                        const low = b.low_greater_than_or_equal_to_percent;
                        const high = b.high_less_than_percent;
                        let label = "";

                        if (low == null && high != null) label = `<${Math.round(high * 100)}%`;
                        else if (low != null && high == null) label = `>=${Math.round(low * 100)}%`;
                        else label = `>=${Math.round(low * 100)}% to <${Math.round(high * 100)}%`;

                        return (
                          <div key={`acv-${rType}-${idx}`} style={{ display: "flex", alignItems: "center", whiteSpace: "nowrap" }}>
                            <div style={{ width: "15px", height: "15px", backgroundColor: b.color, marginRight: "5px", flexShrink: 0 }}></div>
                            <span style={{ fontSize: "0.75rem" }}>{label}</span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
      {hasExcludedWeeklyReps && (
        <div
          style={{
            marginTop: "0.75rem",
            padding: "0 10px",
            fontSize: "0.95rem",
            color: "#333",
          }}
        >
          <span style={{ color: "#f57c00", fontWeight: 700, marginRight: "6px" }}>*</span>
          Color coding unavailable: Weekly Goal is 0 or Rep Type is unspecified.
        </div>
      )}
    </div>
  );
}

export default QualifiedPipelineTable;
